import Breadcrumbs from "components/general/Breadcrumbs";
import { Box, Button, Divider, H1, HStack, Link, ScrollView, Text } from "components/ui";
import { useLocalSearchParams, usePathname } from "expo-router";
import { Boxes, ChevronDown } from "lucide-react-native";
import React from "react";
import { useGetOrderQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import OrdersFilter from "./OrdersFilter";
import PageHeader from "components/general/Headers/PageHeader";

type Props = {
	onSiteChange: (groupIdCollection: number[]) => void;
	onOrderByChange: (siteIdCollection: number[]) => void;
	onDateChange: (dates: any) => void;
	onOrderTypeChange: (orderType: string) => void;
	onSearchFilterChange: (searchFilter: string) => void;
	onShowAwaitingApproval: (value: boolean) => void;
	startDate?: Date | null;
	endDate?: Date | null;
	orderType?: string;
	isDashboard?: boolean;
};

const OrdersHeader = ({ onSiteChange, onOrderByChange, onDateChange, onOrderTypeChange, onSearchFilterChange, onShowAwaitingApproval, startDate, endDate, orderType, isDashboard = false }: Props) => {
	const isMobile = useIsMobile();

	if (isMobile) {
		return (
			<>
				<Box paddingHorizontal={isMobile ? 12 : 0} paddingVertical={20}>
					<Breadcrumbs />
				</Box>
				<Box flexDirection="row" paddingHorizontal={isMobile ? 12 : 0} mb={isMobile ? 24 : 38}>
					<H1>Orders</H1>
				</Box>
				{/* <Box marginVertical={24} paddingHorizontal={12}>
					<Button padding={12} bg="$primarylight" gap={8}>
						<Boxes size={16} color="white" />
						<Text color="$basicwhite" fontWeight={"bold"}>
							Create order
						</Text>
					</Button>
					<Divider bg="$neutral100" my={16} />
					<Button padding={12} bg="$basicwhite" borderWidth={1} borderColor="$primarylight" gap={8}>
						<Text color="$primarylight" fontWeight={"bold"}>
							Show Filters
						</Text>
						<ChevronDown color="#2B6FBB" />
					</Button>
				</Box> */}
				{/* <Box bg="$neutral25" paddingVertical={32} paddingHorizontal={12}>
					<ScrollView horizontal>
						<HStack>
							{TabCollection.map((child: any, index: number) => (
								<OrderLink key={index} tabData={child} />
							))}
						</HStack>
					</ScrollView>
				</Box> */}
			</>
		);
	}
	return (
		<>
			{!isDashboard && <PageHeader title="Orders" />}

			<Box mt={isDashboard ? 47 : 0} paddingHorizontal={isDashboard ? 0 : 48} zIndex={10}>
				<OrdersFilter
					onSiteChange={onSiteChange}
					onOrderByChange={onOrderByChange}
					onDateChange={onDateChange}
					onOrderTypeChange={onOrderTypeChange}
					onSearchFilterChange={onSearchFilterChange}
					onShowAwaitingApproval={onShowAwaitingApproval}
					startDate={startDate}
					endDate={endDate}
					orderType={orderType}
				/>
			</Box>
		</>
	);
};

export default OrdersHeader;
